module.exports = __webpack_public_path__ + "img/PANDO.f539812e.png";